module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/kv_bg_pc_3-e615e52cb7e76c246ef133f977f8b60d.jpg";